
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { namespace } from 'vuex-class';
import { Client } from '@/types';

import ChangePasswordForm from '../components/ChangePasswordForm.vue';
import CardActions from '../components/CardActions.vue';
import ClientList from '../components/ClientList.vue';

const Auth = namespace('Auth');
const Config = namespace('Config');
const Loader = namespace('Loader');

// eslint-disable-next-line no-shadow
enum Step {
  ResetPassword,
  ResetPasswordSuccess,
}

@Component({
  components: {
    ChangePasswordForm,
    ValidationObserver,
    ValidationProvider,
    CardActions,
    ClientList,
  },
})
export default class PasswordReset extends Vue {
  title = 'Reset password';

  readonly Step = Step;

  private stepVal: Step = Step.ResetPassword;

  private newPassword = '';

  @Auth.Action
  private readonly resetPassword!: (data: {
    username: string;
    token: string;
    newPassword: string;
    clientId?: string;
  }) => Promise<boolean>;

  @Loader.Action('run')
  private readonly runWithLoader!: <T>(fn: Promise<T>) => Promise<T>;

  @Config.Getter
  private readonly redirectUri!: string | null;

  @Auth.Getter
  private readonly clients!: Client[];

  get username(): string | undefined {
    return this.$route.query.username?.toString();
  }

  get clientId(): string | undefined {
    return this.$route.query['client-id']?.toString();
  }

  get token(): string | undefined {
    return this.$route.query.token?.toString();
  }

  get step(): Step {
    return this.stepVal;
  }

  set step(value: Step) {
    this.$store.dispatch('clearError');
    this.stepVal = value;
  }

  mounted(): void {
    this.$router.onReady(() => {
      const { action } = this.$route.params;
      if (action === 'create') {
        this.title = 'Create password';
      }
    });

    this.$store.dispatch('clearError');
  }

  async handleResetPassword(): Promise<void> {
    const result = await this.runWithLoader(
      this.resetPassword({
        username: this.username || '',
        token: this.token || '',
        newPassword: this.newPassword,
        clientId: this.clientId,
      }),
    );

    if (result) {
      this.step = Step.ResetPasswordSuccess;
    }
  }

  redirect(): void {
    if (this.redirectUri) {
      window.location.href = this.redirectUri;
    }
  }
}
